import GeneralHelper from "./generalHelper"
import ColorHelper from "./colorHelper"
import View from "./View"
import Favorites from "./favorites"
import UILocalizedMessage from "./UIMessage"
import MessageDictionary from "./MessageDictionary"
import { General } from "./metafiles"

export default class PatternBuilder {
  renderTo(el) {
    let structure = '<div id=\"tabs\">' + 
    '   <div id=\"wizard\" class=\"pattern-builder\">'+
    '      <div id=\"wizard-container\">'+
    '         <div class=\"wizard-options clearfix\">'+
    '            <div class=\"wizard-sections-container\">'+
    '               <div class=\"expanded-pattern clearfix\">'+
    '                  <div id=\"rulerBarY\"></div>'+
    '                  <div id=\"rulerBarX\"></div>'+
    '                  <div id=\"CadXCanvas\"></div>'+
    '                  <div class=\"toolbar-container\"> <i class=\"icon-zoom-out-magnify-glass\"></i> <i class=\"icon-zoom-in-magnify-glass\"></i> <i class=\"icon-refresh\"></i> <input type=\"range\" min=\"1\" step=\"0.1\" > </div>'+
    '                  <div class=\"logo\"></div>'+
    '                  <div class=\"expanded-title\"></div>'+
    '                  <div class=\"copyright\"></div>'+
    '                  <div id=\"pattern-builder-headline\"><span><span class=\"headline-container\"><span class=\"title\">CAD-CUT&reg; Patterns</span> <span class=\"subtitle\">Heat Transfer Vinyl</span></span></span></div>'+
    '                  <div id=\"pattern-builder-maintenance\" style=\"background-image:url(https://assets.stahls.com/stahls/wizards/pattern-builder/maintenance.jpg)\"></div>'+
    '               </div>'+
    '               <ul class=\"tab-list patterns\">'+
    '                  <li class=\"choose-collection pattern-tab\"> <a href=\"#choose-collection\" class="choose-collection-link"></a> </li>'+
    '                  <li class=\"choose-pattern pattern-tab\"> <a href=\"#choose-pattern\" id=\"select-pattern\" class="choose-pattern-link"><span>Select Pattern</span></a> </li>'+
    '                  <li class=\"choose-color pattern-tab\"> <a href=\"#choose-color\" id=\"select-color\" class="choose-color-link"><span>Select '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+'s</span></a> </li>'+
    '                  <li class=\"order-info pattern-tab\"> <a href=\"#order-info\" class="order-info-link"><span>Select Material</span></a> </li>'+
    '               </ul>'+
    '               <div id=\"pattern-steps\">'+
    '                  <!-- Home --> <div id=\"choose-collection\" class=\"tab-content pattern-holder choose-collection\" style=\"border-bottom: 0px;\"> '+
    '                  <div class=\"pb-breadcrumbs\">'+
    '                     <h2>Collection Home</h2>'+
    '                  </div>'+
    '                  <div id=\"collections-container\">'+
    '                     <div class=\"heading-section\">'+
    '                        <h2>Select a collection to get started</h2>'+
    '                        <div class=\"search-box-container\">'+
    '                           <div class=\"error_msg\"> <label for=\"search\" class=\"error\"></label> </div>'+
    '                           <div class=\"input-container\"><input type=\"text\" class=\"search-box\" name=\"search\" placeholder=\"Search\" /><a class=\"search-button\"></a></div>'+
    '                        </div>'+
    '                     </div>'+
    '                     <div id=\"collection-squares\" class=\"designer-select\"></div>'+
    '                  </div>'+
    '                  <div class=\"steps-nav\">'+
    '                     <div class=\"error-msg\"></div>'+
    '                  </div>'+
    '               </div>'+
    '               <!-- Step 01 --> <div id=\"choose-pattern\" class=\"tab-content pattern-holder choose-pattern\" style=\"border-bottom: 0px;\"> '+
    '               <div class=\"pb-breadcrumbs\">'+
    '                  <h2 class=\"browser-container\"></h2>'+
    '               </div>'+
    '               <div id=\"patterns-container\">'+
    '                  <div class=\"heading-section\">'+
    '                     <h2 id=\"BrowserHeading\"></h2>'+
    '                     <div class=\"search-box-container\">'+
    '                        <div class=\"error_msg\"> <label for=\"search\" class=\"error\"></label> </div>'+
    '                        <div class=\"input-container\"><input type=\"text\" class=\"search-box\" name=\"search\" placeholder=\"Search\" /><a class=\"search-button\"></a></div>'+
    '                        <div class=\"search-options\"> <label><input type=\"radio\" name=\"search-type\" value=\"all\" checked /> <span>Search All</span></label> <label><input type=\"radio\" name=\"search-type\" value=\"inside-current\"> <span>Search <span class=\"search-inside-sub-label\">Category</span></span></label> </div>'+
    '                     </div>'+
    '                  </div>'+
    '                  <div class=\"noFavorites\"> <span>You have not favorited any patterns yet. Show some love to your favorite patterns by clicking the <span class=\"check-logged-in icon-favorites-heart-outline\"></span> icon found on each pattern and they will show up here.</span> </div>'+
    '                  <div id=\"pattern-squares\" name=\"pattern-squares\"></div>'+
    '               </div>'+
    '               <div class=\"steps-nav\"> <a class=\"orangeButton prev-step\" step=\"choose-collection\" data-tab=\"choose-collection\">Back</a> <a class=\"orangeButton next-step\" step=\"choose-color\"  data-tab=\"choose-color\">Next</a> </div>'+
    '            </div>'+
    '            <!-- Step 02 --> <div id=\"choose-color\" class=\"tab-content pattern-holder choose-color\"  style=\"border-bottom: 0px;\"> '+
    '            <div class=\"pb-breadcrumbs\">'+
    '               <h2 class=\"browser-container\"></h2>'+
    '            </div>'+
    '            <div id=\"color-select-section\">'+
    '               <div class=\"select-colors-section\">'+
    '                  <div class=\"select-colors-palette-section\">'+
    '                     <h2>Select Palette</h2>'+
    '                     <br/> '+
    '                     <div class=\"palette-drop-down-container\" id=\"palette-drop-down-container\"> </div>'+
    '                     <br/> '+
    '                  </div>'+
    '                  <h2>Select '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+'s</h2>'+
    '                  <div class=\"choose-color-swatch\">'+
    '                     <div class=\"plugin land-tiles\">'+
    '                        <div class=\"clearfix promo-masonry\"></div>'+
    '                     </div>'+
    '                  </div>'+
    '               </div>'+
    '               <div> <a class=\"check-logged-in orangeButton\" data-tab=\"choose-pattern\" id=\"add-to-favorites\">Save your '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination</a> <span class=\"successSave\" style=\"display:none;\"><i class=\"icon-checkmark-heavy greenCheck\"></i>&nbsp;Your custom color combination has been saved!</span> <br/> <br/> </div>'+
    '               <div id=\"select-favorites-section favoriteSection\" >'+
    '                  <h2 class=\"color-combo-heading\"> <span class=\"mult-color-combo\"> <span class=\"has-select-colors hasSelectColorsPadding\" >Your custom '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combinations&nbsp;<span class=\"icon-information-note tooltip\"><span class=\"tooltiptext positionColorComboTooltip\">Your custom color combination for this pattern are saved here.</span></span></span> </span> </h2>'+
    '                  <div id=\"noPatternMessage\"><span class=\"noPatternMessage\" >No custom '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combinations were found for this pattern</span></div>'+
    '               </div>'+
    '               <div id=\"pattern-favorite-sets\" name=\"pattern-favorite-sets\"></div>'+
    '               <div id=\"favorites-section\">'+
    '                  <h2 class=\"color-combo-heading\"> <span class=\"mult-color-combo\"> <span class=\"has-select-colors\">Or select</span> <span class=\"no-select-colors hideElement\" >Select</span> from these popular '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combinations </span> <span class=\"one-color-combo hideElement\" >This pattern has only one '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination</span> </h2>'+
    '               </div>'+
    '               <div id=\"pattern-default-sets\" name=\"pattern-default-sets\"></div>'+
    '            </div>'+
    '            <div class=\"steps-nav\"> <a class=\"orangeButton prev-step\" step=\"choose-pattern\" data-tab=\"choose-pattern\" >Back</a> <a class=\"orangeButton next-step\" data-tab=\"order-info\" step=\"order-info\">Next</a> <a class=\"orangeButton\" data-tab=\"order-info\" style=\"position:absolute; right: 100px; bottom: 6px; \" id=\"download-button\">Download</a></div></div>'+
    '         </div>'+
    '         <!-- Step 03 --> <div id=\"order-info\" class=\"tab-content pattern-holder order-info\" style=\"border-bottom: 0px;\"> '+
    '         <div class=\"pb-breadcrumbs\">'+
    '            <h2 class=\"browser-container\"></h2>'+
    '         </div>'+
    '         <div class=\"pattern-summary\">'+
    '            <div class=\"item-qty wizard-inputs pattern-step-order\"></div>'+
    '            <div id=\"sticky-container\">'+
    '               <div class=\"reset-buttons\"> <a class=\"reset-button wizardButton\" onclick=\"window.viewResetPatternBuilder();\">Start Over</a> </div>'+
    '               <div class=\"previewPanel\">'+
    '                  <div class=\"preview-panel-selections wizard-section wizard-shadow\">'+
    '                     <p class=\"toggle-summary\"> <span class=\"wiz-desc\"> <strong>Order Summary:</strong> <span class=\"wizard-name\">CAD-CUT&reg; Patterns</span> </span> <span class=\"mobile-only fa fa-caret-down\"></span> </p>'+
    '                     <div class=\"preview-panel-summary showBlock\" >'+
    '                        <div class=\"pattern\"> <strong>Pattern:</strong> <span class=\"summary-pattern\"></span> </div>'+
    '                        <div class=\"colors\">'+
    '                           <div><strong>Selected '+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'color')+' combination:</strong></div>'+
    '                           <div class=\"summary-colors\"></div>'+
    '                        </div>'+
    '                     </div>'+
    '                  </div>'+
    '                  <p class=\"totals\">Total Price: <span><strong class=\"total-price\">$0.00</strong></span></p>'+
    '               </div>'+ 
    '               <div id=\"wiz-add-cart\">'+
    '                  <div class=\"addCartBtn disabled-add\"> <a class=\"noShopAdd disabled disallow-add\"> <span class=\"no-add\"> <i class=\"icon-add-to-cart \"></i> Add to Cart </span> </a> </div>'+
    '                  <div class=\"addCartBtn loading-add\"> <a class=\"noShopAdd disabled loading\"> <span class=\"please-wait\"> <i class=\"fa fa-circle-o-notch fa-inverse fa-spin\"></i> Please wait... </span> </a> </div>'+
    '                  <div class=\"addCartBtn enabled-add\"> <a class=\"addToCart shopAdd check-logged-in\" id=\"add-to-cart\"> <span class=\"allow-add\"> <span class=\"add-cart\"> <i class=\"icon-add-to-cart\"></i> Add to Cart </span> <span class=\"update-cart\"> <i class=\"icon-refresh\"></i> Update Item </span> </span> <span class=\"adding\"> <span class=\"add-cart\"> <i class=\"fa fa-circle-o-notch fa-inverse fa-spin\"></i> Adding... </span> <span class=\"update-cart\"> <i class=\"fa fa-circle-o-notch fa-inverse fa-spin\"></i> Updating... </span> </span> <span class=\"added\"> <span class=\"add-cart\"> <i class=\"icon-checkmark-heavy\"></i> Added! </span> <span class=\"update-cart\"> <i class=\"icon-checkmark-heavy\"></i> Updated! </span> </span> </a> </div>'+
    '               </div>'+
    '            </div>'+
    '         </div>'+
    '         <div class=\"steps-nav\"> <a class=\"orangeButton prev-step\" data-tab=\"choose-color\" step=\"choose-color\">Back</a> <a class=\"orangeButton\" data-tab=\"order-info\" style=\"position:absolute; right: 200px; bottom: 6px; \" id=\"export-async-button\">Export Async</a></div>'+
    '      </div>'+
    '   </div>'+
    '</div>'+
    '</div>'+ 
    '</div>'+ 
    '</div>'+
    '</div>';
    $('#'+el).html(structure);
  }
  config() {
    return this._config ;
  }
  constructor (c) {
    this._config = c ;
  }
  render(el) {
    var colorSet = ( GeneralHelper.get_query_string('cadx.colorset') == null ) ? "/DESIGNER/PUBLIC/**" : GeneralHelper.get_query_string('cadx.colorset') ;
    let edit = GeneralHelper.get_query_string("EDITPATTERNID") ;

    Cx.ready(function(){

      window.PatternBuilder.renderTo(el);

      $("#tabs ul").idTabs({
        "displayTabCallback": function(id, all, container, settings){
            View.resize();
            return true;
        }
    });

      window.PatternBuilderCart.Init("#wizard.pattern-builder .wizard-sections-container")

      window.AppInstance.instance().canvas = new Cx.Canvas(
      {
        appendTo: document.getElementById('CadXCanvas'),
        tool: Cx.Tool.Pan(),
        plugins: [
          Cx.Plugin.UserLines()
        ]
      });

      $('input[type="range"]').rangeslider({
        polyfill: false,
        onInit: function() {

        },
        // Callback function
        onSlide: function(position, value) {
          window.AppInstance.instance().canvas.zoom = value;
          window.AppInstance.instance().rulerX.drawBar();
          window.AppInstance.instance().rulerY.drawBar();
          window.AppInstance.instance().canvas.render$();
        },
      });

      //wizardLoading(true, true, false);
      var requestModel = {
        Match : {
          Tags: [{ Name: colorSet }],
          Archived: false, Hidden: false, Owned: true, Shared: true
        }
        , SortBy: 'Modified'
        , SortDir: 'Asc'
      };

      window.AppInstance.instance().rulerY = new RulerBar({ canvas: window.AppInstance.instance().canvas, renderTo: 'rulerBarY', type: 'vertical', userlines: false });
      window.AppInstance.instance().rulerX = new RulerBar({ canvas: window.AppInstance.instance().canvas, renderTo: 'rulerBarX', type: 'horizontal', userlines: false });

      function remove_last_tag(tag)
      {
        var cs = colorSet.split('/');
        cs.pop();
        return cs.join('/');
      }

      window.AppInstance.instance().color_set = {};

      UILocalizedMessage.init$(Cx.Localization[window.PatternBuilder.config().LOCALIZATION]).then(function() {
        Cadx.Core.Color.search$(requestModel).then(function (response_model) {
          var ps = [];
          Cx_.forEach(response_model.Items, function (color, i) {
            //color_set.push({ name: color.Name, r: color.RGB_R / 255, g: color.RGB_G / 255, b: color.RGB_B / 255, hex: argbToRGB(color.ARGB) });
            var tag = Cx_.find(color.Tags, function(t) { return ( t.Name.toUpperCase().indexOf(remove_last_tag(colorSet).toUpperCase()) > -1 ) ; } );
            if ( tag !== undefined )
            {
              if ( window.AppInstance.instance().color_set[tag.Name] === undefined )
                window.AppInstance.instance().color_set[tag.Name] = [];
              window.AppInstance.instance().color_set[tag.Name].push({ name: color.Name, r: color.RGB_R / 255, g: color.RGB_G / 255, b: color.RGB_B / 255, hex: ColorHelper.argbToRGB(color.ARGB) });
            }
          });
          var s = undefined ;
          var color_set_length = GeneralHelper.color_set_length(window.AppInstance.instance().color_set) ;
          if ( color_set_length > 0 )
          {
            s = $('<select id="palette-drop-down" />');
            for ( var key in window.AppInstance.instance().color_set ) {
                $('<option />', { value: key, text: key.split("/").pop() }).appendTo(s);
            }
            s.appendTo(document.getElementById('palette-drop-down-container')) ;
            $("#palette-drop-down")[0].selectedIndex = 0 ;
            if ( color_set_length == 1 ) //select option 1 and hide container
                $('.select-colors-palette-section').hide();
          }
          else {
            $('.select-colors-palette-section').hide();
            s = $('<span>No palettes has been set up yet</span>')
          }

          //finally get favorites and edit pattern job data
          Favorites.get_favorite_documents$().then(function(r) {
            window.AppInstance.instance().favorites =  r ;
          });

          ///weird webpack bug

          if ( edit ) 
          {
            Cx.Core.Config.read$({ Id: window.AppInstance.instance().EDITPATTERNID, Tags: [{ Name: 'patternbuilder/EDITPARAMS' }] }).then(function(r) {
              if ( r.Data )
                window.AppInstance.instance().editParams = JSON.parse(r.Data) ;
              View.reset();
            }, function(e) { GeneralHelper.errorOut(e); })
            
          }

          else if ( window.AppInstance.instance().GROUPID !== null && window.AppInstance.instance().SHOPPERID !== null ) {
            var url = window.PatternBuilder.config().STAHLS_API_BASE + ( ( window.AppInstance.instance().SHOPPERID !== null ) ? "shoppers/" + window.AppInstance.instance().SHOPPERID + "/" : "") + "cart/groups" + ( ( window.AppInstance.instance().GROUPID !== null ) ? "/" + window.AppInstance.instance().GROUPID : "") ;
              $.ajax({
                  type: "GET",
                  url: url,
                  crossDomain: true,
                  contentType: "application/json"
              }).then(function (data) {
                  if (data) {
                  $(".shopAdd").addClass("update-group");
                  PatternBuilderCart.editParams.jobData = data.jobData;
                  if (data.items) {
                      PatternBuilderCart.editParams.items = {};
                      for (var i = 0, len = data.items.length; i < len; i++) {
                        var sku = $.trim(data.items[i].sku);
                        var uofm = $.trim(data.items[i].unitOfMeasure);
                        var qty = $.trim(data.items[i].quantity);
                        if (typeof (PatternBuilderCart.editParams.items[sku]) === "undefined") {
                          PatternBuilderCart.editParams.items[sku] = {};
                        }
                        PatternBuilderCart.editParams.items[sku][uofm] = qty;
                      }
                    }
                  }
                  window.AppInstance.instance().editParams = PatternBuilderCart.editParams ;
                  View.reset();
              }).fail(function () { // Group ID does not exist
                window.AppInstance.instance().GROUPID = undefined ;
                View.reset();
              });
          }

          else {
            View.reset();
          }
  
        })
        .catch(function(e) {
          GeneralHelper.errorOut(e);
        });
      });


      if ( parent && parent.postMessage )
      {
        window.addEventListener('message', function(e) { 
            if ( e.data.credentials )
            {
              if ( e.data.credentials && e.data.credentials.shopperId && e.data.credentials.customerHash )
              {
                window.AppInstance.instance().SHOPPERID = e.data.credentials.shopperId ;
                window.AppInstance.instance().CUSTOMER_HASH = e.data.credentials.customerHash ;
            
                if ( e.data.origin.sender )
                  $('#' + e.data.origin.sender ).click();            
              }
            }
            else if ( e.data.GROUPID )
            {
              window.AppInstance.instance().GROUPID = e.data.GROUPID;
            }
            else if ( e.data.FIELDNAME )
            {
              window.AppInstance.instance().FIELDNAME = e.data.FIELDNAME;
              window.AppInstance.instance().ARTWORKUPLOADER =  e.data.FIELDNAME && e.data.STEPINDEX;
            }
            else if ( e.data.STEPINDEX )
            {
              window.AppInstance.instance().STEPINDEX = e.data.STEPINDEX;
              window.AppInstance.instance().ARTWORKUPLOADER =  e.data.FIELDNAME && e.data.STEPINDEX;
            }
            else if ( e.data.dimensions )
            {
              window.AppInstance.instance().FRAME_WIDTH  = e.data.dimensions.width;
              window.AppInstance.instance().FRAME_HEIGHT = e.data.dimensions.height;
            }
            else if ( e.data.EDITPATTERNID )
            {
              window.AppInstance.instance().EDITPATTERNID = e.data.EDITPATTERNID;
            }
            //logout sent
            else if ( e.data && e.data.origin && e.data.origin.sender ) {
              parent.postMessage(JSON.stringify({ sender : e.data.origin.sender, type: "LOGGED_OUT"}), "*" );
              GeneralHelper.reset_CUSTOMER_HASH(); 
              Cx.User.setSession(GeneralHelper.get_query_string('cadx.app.sid'));
            }
          }
        );
      }

    });
  }
};

